"use client";
import { duration as e, motionRecipe as t, spring as n } from "../foundations/motion/motion-tokens.js";
import { useMotionPolicy as r } from "./useMotionPolicy.js";
import { AnimatePresence as i, motion as a, useIsPresent as o } from "motion/react";
import { jsx as s } from "react/jsx-runtime";
import c from "clsx";
import { forwardRef as l } from "react";
//#region src/motion/StateContent.tsx
var u = l(function({ children: r, icon: i, success: c, keyboard: l, reduced: u, value: d }, f) {
	let p = o(), m = u || l ? 0 : i ? t.iconBlur : t.textBlur, h = c && !u && !l ? "scale(0.9) rotate(20deg)" : "scale(1) rotate(0deg)";
	return /* @__PURE__ */ s(a.span, {
		ref: f,
		"aria-hidden": !p || void 0,
		className: "pf:inline-flex pf:items-center pf:justify-center pf:min-w-0",
		initial: !l && {
			opacity: 0,
			filter: `blur(${String(m)}px)`,
			transform: h
		},
		animate: {
			opacity: 1,
			filter: "blur(0px)",
			transform: "scale(1) rotate(0deg)"
		},
		exit: {
			opacity: 0,
			filter: `blur(${String(m)}px)`,
			transition: { duration: l ? 0 : e.instant / 1e3 }
		},
		transition: l ? { duration: 0 } : u || d ? {
			duration: e.fast / 1e3,
			ease: [
				.23,
				1,
				.32,
				1
			]
		} : c ? n.expressive : n.snappy,
		children: r
	});
});
function d({ children: e, state: t, icon: n = !1, success: a = !1, value: o = !1 }) {
	let l = r();
	return /* @__PURE__ */ s("span", {
		className: c("pf:relative pf:inline-grid pf:align-middle pf:min-w-0", n && "pf:flex-none"),
		children: /* @__PURE__ */ s(i, {
			initial: a,
			mode: "popLayout",
			children: /* @__PURE__ */ s(u, {
				...l,
				icon: n,
				success: a,
				value: o,
				children: e
			}, t)
		})
	});
}
//#endregion
export { d as StateContent };
